import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { LeadActions } from './lead.actions';

@Injectable({
  providedIn: 'root'
})
export class LeadEffects {
  sendLeadEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendLeadEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(LeadActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
